// extracted by mini-css-extract-plugin
export default {"thankYouHeader":"_3Hs-gV81B0QA0htOrq5B3p","thankYouBody":"_1ZnDDOCynKMq5Q08SqxQh8","thankYouButton":"_2UdGxMemQAU5DFBx1_gIB8"};